import { useEffect, useState } from "react";
import { useLang } from "@/context/LanguageContext";
import { Quote, ChevronLeft, ChevronRight } from "lucide-react";

const REVIEWS = [
  {
    quote_en: "We came for the river, we stayed for the people. Naljuri Inn felt like a home we didn't know we needed in Sylhet.",
    quote_bn: "আমরা এসেছিলাম নদীর জন্য, থেকে গেলাম মানুষদের জন্য। নলজুরি ইন যেন সিলেটে আমাদের অজানা একটা ঘর।",
    name: "Tasnim & Adib", meta: "Family travelers · Dhaka",
  },
  {
    quote_en: "The cricket field at sunrise, hot showers after the trek, and the most considerate host. A complete basecamp.",
    quote_bn: "সূর্যোদয়ে ক্রিকেট মাঠ, ট্রেকের পর গরম পানির গোসল, আর সবচেয়ে যত্নশীল হোস্ট। এক পরিপূর্ণ বেসক্যাম্প।",
    name: "Rakib Hasan", meta: "Adventure traveler · Chittagong",
  },
  {
    quote_en: "We've stayed at every Sylhet resort that calls itself eco. This one actually means it. Quiet, clean, serious about service.",
    quote_bn: "সিলেটের সব ইকো-রিসোর্টেই থেকেছি। এই একটাই আসলে কথা রাখে। শান্ত, পরিচ্ছন্ন আর সেবার ব্যাপারে সিরিয়াস।",
    name: "Saima Karim", meta: "Returning guest · Sylhet",
  },
];

export default function Testimonials() {
  const { t, lang } = useLang();
  const [i, setI] = useState(0);

  useEffect(() => {
    const id = setInterval(() => setI((p) => (p + 1) % REVIEWS.length), 7000);
    return () => clearInterval(id);
  }, []);

  const r = REVIEWS[i];
  return (
    <section className="bg-forest-700 text-cream-100 relative overflow-hidden" data-testid="testimonials-section">
      <div className="absolute inset-0 grain-overlay" />
      <div className="max-w-[1100px] mx-auto px-6 md:px-12 py-24 md:py-32 relative">
        <div className="flex items-end justify-between mb-10">
          <div>
            <p className="eyebrow text-gold-400 flex items-center gap-3">
              <span className="inline-block w-7 h-px bg-gold-400/80"></span>
              {t.testimonials.eyebrow}
            </p>
            <h2 className={`mt-4 text-3xl md:text-4xl font-display tracking-tight leading-tight ${lang==='bn'?'font-bn':''}`}>
              {t.testimonials.title}
            </h2>
          </div>
          <div className="hidden md:flex gap-2">
            <button onClick={() => setI((i - 1 + REVIEWS.length) % REVIEWS.length)} data-testid="testimonial-prev"
                    className="w-11 h-11 rounded-full border border-cream-100/30 flex items-center justify-center hover:bg-cream-100/10 transition-colors">
              <ChevronLeft className="w-4 h-4" />
            </button>
            <button onClick={() => setI((i + 1) % REVIEWS.length)} data-testid="testimonial-next"
                    className="w-11 h-11 rounded-full border border-cream-100/30 flex items-center justify-center hover:bg-cream-100/10 transition-colors">
              <ChevronRight className="w-4 h-4" />
            </button>
          </div>
        </div>

        <div className="relative min-h-[220px]" data-testid="testimonial-content">
          <Quote className="w-12 h-12 text-gold-400/30 absolute -top-3 -left-2" />
          <blockquote key={i} className={`fade-up text-2xl md:text-4xl font-display leading-snug max-w-3xl ${lang==='bn'?'font-bn':''}`}>
            "{lang === 'en' ? r.quote_en : r.quote_bn}"
          </blockquote>
          <div className="mt-8 flex items-center gap-4">
            <div className="w-10 h-px bg-gold-400/50" />
            <div>
              <div className="text-sm">{r.name}</div>
              <div className="text-[11px] uppercase tracking-widest2 text-cream-100/60 mt-0.5">{r.meta}</div>
            </div>
          </div>
        </div>

        <div className="mt-10 flex gap-2">
          {REVIEWS.map((_, idx) => (
            <button key={idx} onClick={() => setI(idx)} data-testid={`testimonial-dot-${idx}`}
                    className={`h-px transition-all ${idx === i ? 'w-12 bg-gold-400' : 'w-6 bg-cream-100/30'}`} />
          ))}
        </div>
      </div>
    </section>
  );
}
